import api from '@/libs/axiosInstance';
import type { BulkEmailAttachmentUploadResponse } from '@fluenceur/types';
import { useMutation } from '@tanstack/react-query';

export function useUploadBulkEmailAttachment() {
  return useMutation({
    mutationFn: async ({
      file,
      sessionId,
    }: {
      file: File;
      sessionId: string;
    }): Promise<BulkEmailAttachmentUploadResponse> => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('sessionId', sessionId);

      const response = await api.post('/dashboard/affiliates/bulk-email/attachments', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data.data;
    },
  });
}
